import { ArrowUpRight, Heart, Headphones, Radio } from 'lucide-react';
import { motion } from 'framer-motion';
import { date, money, number } from '../format';
import type { Order } from '../types';
import StatusBadge from './StatusBadge';

export default function OrderCard({ order, compact = false }: { order: Order; compact?: boolean }) {
  const Icon = order.category?.includes('likes') ? Heart : order.category === 'listeners' ? Radio : Headphones;
  const percent = Math.max(0, Math.min(100, Number(order.progress || 0)));
  return (
    <motion.article className={`order-card ${compact ? 'order-compact' : ''}`} layout>
      <div className={`service-icon tone-${order.accent || 'orange'}`}><Icon size={19} /></div>
      <div className="order-main">
        <div className="order-title-row">
          <div><h3>{order.title}</h3><p>Заказ #{order.id} · {date(order.created_at)}</p></div>
          <StatusBadge status={order.status} />
        </div>
        <div className="order-progress"><span><i style={{ width: `${percent}%` }} /></span><b>{percent}%</b></div>
        <div className="order-meta"><span>{number(Math.round(order.quantity * percent / 100))} / {number(order.quantity)}</span><strong>{money(order.amount)}</strong></div>
      </div>
      {!compact && <a className="icon-button subtle" href={order.target_url} target="_blank" rel="noreferrer" aria-label="Открыть ссылку"><ArrowUpRight size={18} /></a>}
    </motion.article>
  );
}
